import { Stack, Tooltip, Typography } from '@mui/material'
import { SearchScopeType } from 'api/model'
import { convertScopeToVisibility } from './MyTwinEmails'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import Selector from 'components/Selector'
import { COLORS } from 'app-constants'

const searchScopes = Object.values(SearchScopeType)

const SearchScopeSelector = ({
  disabled,
  entityName,
  searchScope,
  setSearchScope,
}: {
  disabled: boolean
  entityName?: string
  searchScope: SearchScopeType
  setSearchScope: (searchScope: SearchScopeType) => void
}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {entityName && (
        <Stack direction="row" alignItems="center" spacing="4px">
          <Typography variant="h6">Visibility</Typography>
          <Tooltip
            enterTouchDelay={0}
            title={`${entityName}s marked as private will not be used to generate twin responses in interactions with other users.`}>
            <InfoOutlined
              sx={{
                height: '16px',
                width: '16px',
                color: COLORS.GRAY_3,
              }}
            />
          </Tooltip>
        </Stack>
      )}

      <Selector
        id="search-scope-selector"
        disabled={disabled}
        option={searchScope}
        options={searchScopes}
        setOption={setSearchScope}
        isDarkBackdrop={false}
        width="100px"
        renderCustomValue={(option) => convertScopeToVisibility(option)}
        renderCustomOption={(option) => convertScopeToVisibility(option)}
      />
    </Stack>
  )
}

export default SearchScopeSelector
